import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { useParams } from "react-router-dom";
import TFObject from '../../components/TFObject';
import TFSkeleton from '../../components/Skeleton';
import { loadHomebotContactEvents } from '../../common/api';


const Contact = ( { user, org, accts, viewing, allLoaded, contacts, tasks, events, lists, gifts, leadopps, loans, notes, reviews, comms, files, refsout, setCurrent } ) => {
    let params = useParams();
    const [ loaded, setLoaded ] = useState( false );
    const [ c, setContact ] = useState( { 
        details: {}, 
        leadopps: [], 
        loans: [],
        notes: [], 
        lists: [], 
        tasks: [],
        events: [],
        gifts: [],
        reviews: [],
        referrals: [],
        ba: [],
        la: [],
        referredout: [],
        introduced: [],
        comms: [],
        files:[],
        duplicates: []
    } );
    const [ meta, setMeta ] = useState( {} );
    
    useEffect( () => {
        if ( params.cid ) {
            setCurrent( { cid: params.cid } );
        }
    }, [ params.cid, setCurrent ] );

    // Set primary contact
    // Load referrals
    useEffect( () => {
        if ( allLoaded ) {
            const refQueues = {};

            const c = contacts[params.cid];
            if ( !c ) {
                setLoaded( false );
                return;
            }

            const acct = accts.find( f => {
                if ( c.priRole !== 'partner' || !org || org.sharePartners !== true ) {
                    return ( f.id === c.aid );
                }
                if ( viewing.length === 1 ) {
                    return ( f.id === viewing[0] );
                }
                if ( c.claimedBy && viewing.includes( c.claimedBy ) ) {
                    return ( f.id === c.claimedBy );
                }
                return viewing.includes( f.id );
            } );
            if ( !acct ) {
                setLoaded( false );
                return;
            }

            const meta = acct.crm?.meta;
            setMeta( meta?.contact );

            const gsp = meta?.global?.picklist?.status;
            const lsp = meta?.loan?.picklist?.status;

            const list = [];
            Object.keys( contacts ).forEach( cid => {
                if ( contacts[cid].referredById === params.cid ) {
                    list.push( contacts[cid] );
                }
            } );

            list.forEach( con => {
                let opps = [];
                Object.keys( leadopps ).forEach( loid => {
                    const lo = leadopps[loid];
                    const yes = lo?.relationships?.find( f => f.cid === con.cid );
                    if ( yes ) {
                        opps.push( lo );
                        if ( !yes.lid ) {
                            const q = gsp.find( f => f.value === lo.status );
                            if ( q ) {
                                if ( !refQueues[q.queue] ) {
                                    refQueues[q.queue] = [];
                                }
                                refQueues[q.queue].push( lo );
                            } else {
                                // console.log( 'unknown queue: ', lo, gsp );
                            }
                        } else {
                            console.log( 'skipping lo because of loan: ', lo );
                        }
                    }
                } );
                opps.sort( ( a, b ) => {
                    const ad = new Date( a.oppDate + 'T12:00:00.000' );
                    const bd = new Date( b.oppDate + 'T12:00:00.000' );
                    return bd.getTime() - ad.getTime();
                } );
                con['tfLeads'] = opps;
                con['leadCount'] = opps.length;
                con['leadDateLast'] = opps[0]?.oppDate;
                con['leadDateFirst'] = opps[opps.length - 1]?.oppDate;

                const lb = [];
                Object.keys( loans ).forEach( lid => {
                    const l = loans[lid];
                    const yes = l?.borrowers?.find( f => f.cid === con.cid );
                    if ( yes ) {
                        lb.push( l );
                        const q = lsp.find( f => f.value === l.status );
                        if ( q ) {
                            if ( !refQueues[q.queue] ) {
                                refQueues[q.queue] = [];
                            }
                            refQueues[q.queue].push( l );
                        } else {
                            // console.log( 'unknown queue: ', l, lsp );
                        }
                    }
                } );
                // loans.sort( ( a, b ) => {
                //     const ad = new Date( a.oppDate + 'T12:00:00.000' );
                //     const bd = new Date( b.oppDate + 'T12:00:00.000' );
                //     return bd.getTime() - ad.getTime();
                // } );
                con['tfLoans'] = lb;
            } );

            list.sort( ( a, b ) => {
                if ( !a.leadDateLast && !b.leadDateLast ) {
                    return 0;
                } else if ( !a.leadDateLast ) {
                    return 1;
                } else if ( !b.leadDateLast ) {
                    return -1;
                }
                const ad = new Date( a.leadDateLast + 'T12:00:00.000' );
                const bd = new Date( b.leadDateLast + 'T12:00:00.000' );
                return bd.getTime() - ad.getTime();
            } );
            console.log( 'referrals: ', list );
            console.log( 'reqQueues: ', refQueues );

            setContact( prev => {
                return {
                    ...prev,
                    details: contacts[params.cid],
                    referrals: list,
                    refQueues: refQueues
                }
            } );

            if ( viewing.includes( c.aid ) ) {
                setLoaded( true );
            } else if ( c.priRole === 'partner' && org && org.sharePartners ) {
                console.log( 'showing shared partner even though not in the viewing pool' );
                setLoaded( true );
            } else {
                setLoaded( false );
            }
        }
    }, [ org, params.cid, contacts, leadopps, loans, allLoaded, viewing, accts ] );

    // Load duplicates
    useEffect( () => {
        const list = [];
        const priContact = contacts[params.cid];
        let priEmail = contacts[params.cid]?.email?.toLowerCase();
        
        if ( !priContact ) {
            return;
        }
        
        Object.keys( contacts ).forEach( cid => {
            if ( cid === params.cid ) {
                return;
            }

            const con = contacts[cid];
            if ( !con ) {
                return;
            }
            
            if ( con.priRole !== priContact.priRole ) {
                return;
            }

            // only look for dups in same account or org (if sharing)!!
            if ( con.aid !== priContact.aid ) {
                if ( priContact.priRole !== 'partner' ) {
                    return;
                }
                if ( !org || !org.sharePartners || con.orgId !== priContact.orgId ) {
                    return;
                }
            }

            if ( con.email ) {
                if ( priEmail === con.email.toLowerCase() ) {
                    console.log( 'pushing dup on email match: ' + priEmail );
                    list.push( con );
                    return;
                }
            }

            if ( con.emailPartner1 ) {
                if ( priEmail === con.emailPartner1.toLowerCase() ) {
                    console.log( 'pushing dup on partner1 email match: ' + priEmail );
                    list.push( con );
                    return;
                }
            }

            if ( con.emailPartner2 ) {
                if ( priEmail === con.emailPartner2.toLowerCase() ) {
                    console.log( 'pushing dup on partner2 email match: ' + priEmail );
                    list.push( con );
                    return;
                }
            }

            if ( con.phone ) {
                if ( priContact.phone && con.phone === priContact.phone ) {
                    console.log( 'pushing dup on phone match: ' + con.phone );
                    list.push( con );
                    return;
                }
                if ( priContact.phoneMobile && con.phone === priContact.phoneMobile ) {
                    console.log( 'pushing dup on phone match: ' + con.phone );
                    list.push( con );
                    return;
                }
                if ( priContact.phoneHome && con.phone === priContact.phoneHome ) {
                    console.log( 'pushing dup on phone match: ' + con.phone );
                    list.push( con );
                    return;
                }
                // if ( priContact.phoneWork && con.phone === priContact.phoneWork ) {
                //     console.log( 'pushing dup on phone match: ' + con.phone );
                //     list.push( con );
                //     return;
                // }
            }
            if ( con.phoneMobile ) {
                if ( priContact.phone && con.phoneMobile === priContact.phone ) {
                    console.log( 'pushing dup on phoneMobile match: ' + con.phoneMobile );
                    list.push( con );
                    return;
                }
                if ( priContact.phoneMobile && con.phoneMobile === priContact.phoneMobile ) {
                    console.log( 'pushing dup on phoneMobile match: ' + con.phoneMobile );
                    list.push( con );
                    return;
                }
                if ( priContact.phoneHome && con.phoneMobile === priContact.phoneHome ) {
                    console.log( 'pushing dup on phoneMobile match: ' + con.phoneMobile );
                    list.push( con );
                    return;
                }
                // if ( priContact.phoneWork && con.phoneMobile === priContact.phoneWork ) {
                //     console.log( 'pushing dup on phoneMobile match: ' + con.phoneMobile );
                //     list.push( con );
                //     return;
                // }
            }
            // if ( con.phoneWork ) {
            //     if ( priContact.phone && con.phoneWork === priContact.phone ) {
            //         console.log( 'pushing dup on phoneWork match: ' + con.phoneWork );
            //         list.push( con );
            //         return;
            //     }
            //     if ( priContact.phoneMobile && con.phoneWork === priContact.phoneMobile ) {
            //         console.log( 'pushing dup on phoneWork match: ' + con.phoneWork );
            //         list.push( con );
            //         return;
            //     }
            //     if ( priContact.phoneHome && con.phoneWork === priContact.phoneHome ) {
            //         console.log( 'pushing dup on phoneWork match: ' + con.phoneWork );
            //         list.push( con );
            //         return;
            //     }
            //     if ( priContact.phoneWork && con.phoneWork === priContact.phoneWork ) {
            //         console.log( 'pushing dup on phoneWork match: ' + con.phoneWork );
            //         list.push( con );
            //         return;
            //     }
            // }
            if ( con.phoneHome ) {
                if ( priContact.phone && con.phoneHome === priContact.phone ) {
                    console.log( 'pushing dup on phoneHome match: ' + con.phoneHome );
                    list.push( con );
                    return;
                }
                if ( priContact.phoneMobile && con.phoneHome === priContact.phoneMobile ) {
                    console.log( 'pushing dup on phoneHome match: ' + con.phoneHome );
                    list.push( con );
                    return;
                }
                if ( priContact.phoneHome && con.phoneHome === priContact.phoneHome ) {
                    console.log( 'pushing dup on phoneHome match: ' + con.phoneHome );
                    list.push( con );
                    return;
                }
                // if ( priContact.phoneWork && con.phoneHome === priContact.phoneWork ) {
                //     console.log( 'pushing dup on phoneHome match: ' + con.phoneHome );
                //     list.push( con );
                //     return;
                // }
            }
        } );

        if ( list.length ) {
            console.log( 'dups: ', list );
        }

        setContact( prev => {
            return {
                ...prev,
                duplicates: list
            }
        } );
    }, [ params.cid, contacts, org ] );

    // Load tasks
    useEffect( () => {
        const list = [];
        Object.keys( tasks ).forEach( tid => {
            const t = tasks[tid];

            const yes = t?.assoc?.find( f => f?.cid === params.cid );
            if ( yes ) {
                list.push( t );
            }
        } );
        setContact( prev => {
            return {
                ...prev,
                tasks: list
            }
        } );
    }, [ params.cid, tasks ] );

    // Load events
    useEffect( () => {
        const list = [];
        Object.keys( events ).forEach( e => {
            const yes = events[e]?.members?.find( f => f.cid === params.cid );
            if ( yes ) {
                list.push( { ...events[e], ...yes } );
            }
        } );
        setContact( prev => {
            return {
                ...prev,
                events: list
            }
        } );
    }, [ params.cid, events ] );

    // Load lists
    useEffect( () => {
        const list = [];
        Object.keys( lists ).forEach( gid => {
            const g = lists[gid];
            if ( !g || g.itemType !== 'contacts' || !g.items || !g.items.length ) {
                return;
            }

            const yes = g.items.find( f => f === params.cid );
            if ( yes ) {
                list.push( g );
            }
        } );
        setContact( prev => {
            return {
                ...prev,
                lists: list
            }
        } );
    }, [ params.cid, lists ] );

    // Load gifts
    useEffect( () => {
        const list = [];
        Object.keys( gifts ).forEach( g => {
            const yes = gifts[g]?.recips?.find( f => f && f.cid === params.cid );
            if ( yes ) {
                list.push( gifts[g] );
            }
        } );
        setContact( prev => {
            return {
                ...prev,
                gifts: list
            }
        } );
    }, [ params.cid, gifts ] );

    // Load lead opps
    useEffect( () => {
        const list = [];
        Object.keys( leadopps ).forEach( lo => {
            const yes = leadopps[lo]?.relationships?.find( f => f.cid === params.cid );
            if ( yes ) {
                list.push( { ...leadopps[lo], ...yes } );
            }
        } );
        list.sort( ( a, b ) => {
            const ad = new Date( a.oppDate + 'T12:00:00.000' );
            const bd = new Date( b.oppDate + 'T12:00:00.000' );
            return bd.getTime() - ad.getTime();
        } );
        setContact( prev => {
            return {
                ...prev,
                leadopps: list
            }
        } );
    }, [ params.cid, leadopps ] );

    // Load loans
    useEffect( () => {
        const list = [];
        let ba = [];
        let la = [];

        Object.keys( loans ).forEach( lid => {
            const l = loans[lid];

            const yes = l?.borrowers?.find( f => f.cid === params.cid );
            if ( yes ) {
                list.push( l );
            }

            if ( l.baId === params.cid ) {
                ba.push( l );
            }
            if ( l.laId === params.cid ) {
                la.push( l );
            }
        } );
        list.sort( ( a, b ) => {
            const ad = new Date( a.createdDate );
            const bd = new Date( b.createdDate );
            return bd.getTime() - ad.getTime();
        } );
        ba.sort( ( a, b ) => {
            const ad = new Date( a.createdDate );
            const bd = new Date( b.createdDate );
            return bd.getTime() - ad.getTime();
        } );
        la.sort( ( a, b ) => {
            const ad = new Date( a.createdDate );
            const bd = new Date( b.createdDate );
            return bd.getTime() - ad.getTime();
        } );
        setContact( prev => {
            return {
                ...prev,
                loans: list,
                ba: ba,
                la: la
            }
        } );
    }, [ params.cid, loans ] );

    // Load notes
    useEffect( () => {
        const list = [];
        Object.keys( notes ).forEach( nid => {
            const n = notes[nid];
            const yes = n?.assoc?.find( f => f.cid === params.cid );
            if ( yes && n?.createdDate ) {
                list.push( n );
            }
        } );
        if ( list.length ) {
            list.sort( ( a, b ) => {
                const ad = new Date( a.createdDate.match( 'T' ) ? a.createdDate : a.createdDate + 'T12:00:00' );
                const bd = new Date( b.createdDate.match( 'T' ) ? b.createdDate : b.createdDate + 'T12:00:00' );
                return bd.getTime() - ad.getTime();
            } );
        }

        setContact( prev => {
            return {
                ...prev,
                notes: list
            }
        } );
    }, [ params.cid, notes ] );

    // Load reviews
    useEffect( () => {
        const list = [];
        Object.keys( reviews ).forEach( r => {
            const yes = reviews[r]?.assoc?.find( f => f.cid === params.cid );
            if ( yes ) {
                list.push( reviews[r] );
            }
        } );
        setContact( prev => {
            return {
                ...prev,
                reviews: list
            }
        } );
    }, [ params.cid, reviews ] );

    // Load comms
    useEffect( () => {
        const list = [];
        Object.keys( comms ).forEach( cid => {
            // console.log( 'processing comm: ' + cid );
            const c = comms[cid];
            const yes = c?.assoc?.find( f => f.cid === params.cid );
            if ( yes ) {
                list.push( c );
            }
        } );
        if ( list.length ) {
            list.sort( ( a, b ) => {
                let ad = Date.parse( a.commDate );
                let bd = Date.parse( b.commDate );
                if ( !ad ) {
                    ad = Date.parse( a.createdDate );
                }
                if ( !bd ) {
                    bd = Date.parse( b.createdDate );
                }
                return bd - ad;
            } );
        }

        setContact( prev => {
            return {
                ...prev,
                comms: list
            }
        } );
    }, [ params.cid, comms ] );

    // Load files
    useEffect( () => {
        const list = [];
        Object.keys( files ).forEach( fid => {
            // console.log( 'processing comm: ' + cid );
            const f = files[fid];
            if ( f.cid === params.cid ) {
                list.push( f );
            }
        } );
        if ( list.length ) {
            list.sort( ( a, b ) => {
                if ( b.createdDate < a.createdDate ) {
                    return -1;
                }
                if ( a.createdDate < b.createdDate ) {
                    return 1;
                }
                return 0;
            } );
        }

        setContact( prev => {
            return {
                ...prev,
                files: list
            }
        } );
    }, [ params.cid, files ] );

    // Load refs out
    useEffect( () => {
        let refOut = [];
        let refIn = [];

        Object.keys( refsout ).forEach( roid => {
            const r = refsout[roid];
            if ( r.refOutId === params.cid ) {
                refIn.push( {
                    ...r,
                    to: contacts[r.refToId],
                    out: contacts[r.refOutId] 
                } );
            }
            if ( r.refToId === params.cid ) {
                refOut.push( {
                    ...r,
                    to: contacts[r.refToId],
                    out: contacts[r.refOutId] 
                } );
            }
        } );
        setContact( prev => {
            return {
                ...prev,
                referredout: refOut,
                introduced: refIn
            }
        } );
    }, [ params.cid, refsout, contacts ] );

    useEffect( () => {
        document.title = `Third Floor - ${c?.details?.name}`;
    }, [ c ] );

    // Load homebot activity
    useEffect(() => {
        const fetchData = async () => {
            try {
                const data = await loadHomebotContactEvents( c.details.aid, user.email, params.cid );
                console.log( 'homebot data: ', data );
            } catch ( e ) {
                console.error('Error fetching homebot data:', e );
            }
        };

        console.log( 'checking for homebot data!', user.lists.accounts, c?.details?.aid, user.email );
        if ( user.lists?.accounts && c?.details?.aid ) {
            const acct = user.lists.accounts.find( a => a.id === c.details.aid );
            if ( acct && acct.stack?.homebot ) {
                console.log( 'fetching homebot data!', params.cid, c.details.aid );
                fetchData();
            }
        }
    }, [ user.lists.accounts, params.cid, c, user.email ] );

    return (
        loaded ? (
            <TFObject key={params.cid} objType='contact' obj={c} oid={params.cid} objPick={meta.picklist} header={meta.header} details={meta.details} sidebar={meta.sidebar} />
        ) : (
            <TFSkeleton />
        )
    );
}

const mapProps = ( state ) => ( {
    user: state.user,
    org: state.user.org,
    // meta: state.user.meta.contact,
    accts: state.user.lists.accounts,
    viewing: state.user.viewing,
    allLoaded: state.contacts.loaded,
    contacts: state.contacts.byId,
    tasks: state.tasks.byId,
    events: state.events.byId,
    lists: state.lists.byId,
    gifts: state.gifts.byId,
    leadopps: state.leadopps.byId,
    loans: state.loans.byId,
    notes: state.notes.byId,
    reviews: state.reviews.byId,
    comms: state.comms.byId,
    files: state.files.byId,
    refsout: state.referredout.byId
} );
  
const mapDispatch = ( dispatch ) => ( {
    setCurrent: dispatch.contacts.setCurrent
} );
  
export default connect( mapProps, mapDispatch )( Contact );